import { emptysDates, monthsNames, timeFormat } from "../data/main";
import { convertHour } from "./convertHour";

export default function convertDate({
  info,
  time = true,
  full = false,
  t,
}: {
  info: string;
  time?: boolean;
  full?: boolean;
  t: any;
}) {
  if (emptysDates.includes(info)) {
    return "";
  }
  try {
    if (typeof info === "string") {
      let mainTime = info.split(" ");
      if (timeFormat.order) {
        let tempDate = mainTime[0].split("-"); //.reverse().join("-");

        mainTime[0] = [...timeFormat.order]
          .map((e) =>
            e === 1 && timeFormat.monthName
              ? t(`p.${monthsNames[Number(tempDate[e]) - 1][full ? 1 : 0]}`)
              : tempDate[e],
          )
          .join(timeFormat.delimiter);
      }

      if (time && mainTime.length > 1) {
        mainTime[1] = convertHour(mainTime[1]);
      }
      return time ? mainTime.join(" ") : mainTime[0];
    } else {
      return "";
    }
  } catch (error) {
    console.log("convertDate: ", error);
  }
  return info;
}
